import SMFacilityLink from './SMFacilityLink';

export default SMFacilityLink;
